<template>
  <div>
    <div class="__header-container">
      <h4 class="__header-text">Tarif Harga {{ rowIdx + 1 }}</h4>
      <McButton
        v-if="canEditFields"
        variant="secondary"
        text="Ubah"
        icon="icon-outline_edit"
        @click="$emit('triggerEdit', rowIdx)"
        :disabled="canEdit"
      />
    </div>

    <FormulateForm :formulateValue="data">
      <b-row>
        <b-col md="2" v-for="group in addressFieldsGroups" :key="group.name">
          <h5>{{ group.label }}</h5>
          <b-row>
            <b-col md="6" v-for="field in group.fields" :key="field.name">
              <FormulateInput
                v-bind="field"
                :name="`${group.name}_${field.name}`"
                :initialObject="field.getInitialObject?.(data[`${group.name}_${field.name}`])"
              >
                <template #element="{ slotProps, model }">
                  <div v-if="slotProps?.component?.initialObject" class="fw-bold">
                    {{ slotProps.component.initialObject[field.readOnlyKey] }}
                  </div>
                  <div v-else>{{ model }}</div>
                </template>
                <template #help><span></span></template>
              </FormulateInput>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="3" v-for="field in rateDetailFields" :key="field.name">
          <FormulateInput v-bind="field" :initialObject="field.getInitialObject?.(rate)">
            <template #element="{ slotProps, model }">
              <div v-if="slotProps?.component?.initialObject" class="fw-bold">
                {{ slotProps.component.initialObject[field.readOnlyKey] }}
              </div>
              <div v-else>{{ model }}</div>
            </template>
            <template #help><span></span></template>
          </FormulateInput>
        </b-col>
      </b-row>

      <div class="__base-price-container">
        <div class="__base-price">
          <h5>Tarif Dasar</h5>

          <FormulateInput name="base_price">
            <template #element="{ model }">
              <span>{{ model ? model.toLocaleString() : '-' }}</span>
            </template>
          </FormulateInput>
        </div>
      </div>
    </FormulateForm>
  </div>
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    rowIdx: {
      type: Number,
      default: 0,
    },
    addressFieldsGroups: {
      type: Array,
      default: () => [],
    },
    rateDetailFields: {},
    canEdit: {},
    canEditFields: {},
    isEditing: {},
    data: {},
    rate: {},
  },
  emits: ['triggerEdit'],
}
</script>
